export default __webpack_public_path__ + "static/Entenda0116-36835fcae607712947f0f725e3ac4059.jpg";